import classNames from 'clsx';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';
import { messages } from './messages';
import style from './style.module.css';
import utilityStyle from '../../../../../../css-variables/utilities.module.css';

export const NotesInput = ({ notes = '', setNotes }) => {
  const onAddNotes = useCallback(
    (e) => {
      setNotes(e.target.value);
    },
    [setNotes],
  );

  return (
    <div className={style['input-wrapper']}>
      <Text textType={TextType.Label} value={messages.addToLocationLocationNotesLabel} />
      <div>
        <textarea className={classNames(style['edit-notes'], utilityStyle['input-border'])} onChange={onAddNotes} value={notes} />
      </div>
    </div>
  );
};

NotesInput.propTypes = {
  notes: PropTypes.string,
  setNotes: PropTypes.func.isRequired,
};
